import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { connect } from "react-redux";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Button, Typography, Grid } from '@mui/material';
import { getEventLogFilesLoading,getEventLogsFileData} from "../selector/selectors";
import { loadEventLogFiles} from "../api/eventLogsFileapi";
import LoaderComponent from "../components/LoaderComponent";
import SearchBoxComponent from "../components/SearchBoxComponent";
import SearchByComponent from "../components/SearchByComponent";
import { Link } from "react-router-dom";
import AccessDeniedImg from '../assets/access_denied.png'
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import EventsLogHistory from "../components/EventsLogHistory";


function ManageEventLogs({
    isLoading,
    startLoadingEventLogFiles,
    eventLogFilesList
}) {
  
    const [value, setValue] = React.useState('1');
    
    const navigate = useNavigate();
    const list  = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);
    let roleAccessDenied = false;
    let userAccessDenied = false;
    list?.rolePermissions?.map(rp => rp.key_name === 'manageHistoryLogs' ? roleAccessDenied = true : roleAccessDenied);
    list?.userPermissions?.map(up => up.key_name === 'manageHistoryLogs' ? userAccessDenied = true : userAccessDenied);
    const [radioButtonValue, setRadioButtonValue] = React.useState('0');
    const [searchLabel, setSearchLabel] = React.useState('Genset Serial Number');
    const [searchValue,setSearchValue] = React.useState('');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleSearialChangeTextValue = (event) => {
        setSearchValue(event.target.value);
        startLoadingEventLogFiles(event.target.value,radioButtonValue);    
    };

    useEffect(() => {
        if(roleAccessDenied || userAccessDenied){
            startLoadingEventLogFiles('',radioButtonValue);
        }
        // eslint-disable-next-line
    }, [startLoadingEventLogFiles]);
   
    const handleRadioButtonChange = (event) => {
        if(event.target.value === '1'){
            setSearchLabel('Controller Serial Number');
        } else {
            setSearchLabel('Genset Serial Number');
        }
        setRadioButtonValue(event.target.value);
        startLoadingEventLogFiles(searchValue,event.target.value);
    };


    return (
        <Box sx={{ flexGrow: 1 }} >
        { isLoading &&  (roleAccessDenied || userAccessDenied) ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Link className="tabingLinks" to="/web/firmware">Firmware</Link>
                                <Link className="tabingLinks" to="/web/config-files">Config file history</Link>
                                <Link className="tabingLinks" to="/web/default-files">Default Configuration</Link>
                                <Tab label="Event logs" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                        {(roleAccessDenied || userAccessDenied)  &&
                            <>
                            <Grid container sx={{ paddingBottom: 1 }}>
                                <Grid item xs={12} sm={5} md={5} lg={3} xl={3}>
                                    <SearchByComponent
                                        value={radioButtonValue}
                                        handleRadioButtonChange={handleRadioButtonChange} />
                                </Grid>
                                <Grid item xs={12} sm={7} md={7} lg={9} xl={9}>
                                    <SearchBoxComponent
                                        handleChangeTextValue={handleSearialChangeTextValue}
                                        label={searchLabel} />
                                </Grid>
                            </Grid>
                            <EventsLogHistory searchLabel={searchLabel} logsInfo={eventLogFilesList} />
                            </>

                        }

                        {(roleAccessDenied === false && userAccessDenied === false)  &&
                            <Grid
                                container
                                spacing={0}
                                direction="column"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ minHeight: '80vh' }}
                            >
                                <img style={{maxWidth:'100%'}} alt="access_denied" src={AccessDeniedImg}  />
                                <Typography sx={{paddingBottom:'10px'}} variant="h6">Access Denied</Typography>
                                <Typography sx={{paddingBottom:'20px'}} variant="span">You do not have permission to view this page. </Typography>
                                <Button onClick={(e)=>{navigate('/web/dashboard')}}  variant="contained">Dashboard</Button>
                            </Grid>
                        }
                        </TabPanel>
                    </Grid>
                </TabContext> 
            </Grid>
        </Box>
    );
}

const mapStateToProps = (state) => ({
    isLoading: getEventLogFilesLoading(state),   
    eventLogFilesList: getEventLogsFileData(state),
  });
  
  const mapDispatchToProps = (dispatch) => ({
    startLoadingEventLogFiles: (data,searchBy)  => dispatch(loadEventLogFiles(data,searchBy)),
  });

export default connect(mapStateToProps, mapDispatchToProps)(ManageEventLogs);

